import { fetchLookbookProductsByProductIds } from '@app/services/lookbookRepository';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { skipToken, useQuery } from '@tanstack/react-query';
import { Product, ShowroomApiResponse } from '@typings';
import { AxiosError } from 'axios';

export const LOOKBOOK_PRODUCTS_BY_IDS_QUERY_KEY = 'useLookbookProductsByIds';

interface Props {
  lookbookId: string | undefined;
  products: string[];
}

export const useLookbookProductsByIds = ({ lookbookId, products }: Props) => {
  return useQuery<ShowroomApiResponse & Product.ProductsResultDTO, AxiosError, Product.Full[]>({
    enabled: isDefined(lookbookId) && !isEmpty(products),
    queryFn:
      isDefined(lookbookId) ?
        async () => fetchLookbookProductsByProductIds(lookbookId, products, { limit: products.length, offset: 0 })
      : skipToken,
    queryKey: [LOOKBOOK_PRODUCTS_BY_IDS_QUERY_KEY, lookbookId, products],
    refetchOnMount: false,
    select: data => {
      return data.productsOrder.map(productOrder => data.products[productOrder]).filter(isDefined);
    },
  });
};
